import fetchAPI from '../fetchAPI';

interface callGetUserProps {
  email?: string;
  companyId?: string;
}

export const callGetUser = async (props: callGetUserProps): Promise<iResponse<User>> => {
  const { companyId, email } = props;
  // Encoded, not interpolated: a raw `+` in an address like `sam+test@…` is
  // decoded as a space on the server, the lookup misses, and the account page
  // renders an empty company card with Update Account disabled.
  const params = new URLSearchParams();
  if (email) params.set('email', email);
  if (companyId) params.set('companyId', companyId);
  const queryString = params.toString();

  const response: iResponse<User> = await fetchAPI({
    method: `GET`,
    route: `user`,
    queryString
  });

  // user?companyId=company-id
  // const {error} = response;
  // if (error) throw new ResponseError(error);

  return response;
};

export default callGetUser;
